import React from 'react';
import { Reveal } from './Reveal';
import { methodology } from '../data/about';
interface MethodStepsProps {
  tone?: 'light' | 'dark';
}
export function MethodSteps({
  tone = 'light'
}: MethodStepsProps) {
  const dark = tone === 'dark';
  return <ol className="grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-136" data-mp="3azrdgvdsbby1">
      {methodology.map((step, i) => <li key={step.title} className={`border-t pt-6 ${dark ? 'border-champagne-100/15' : 'border-midnight-900/15'}`} data-id="element-137" data-mp="360wt3p065fbt" data-mpi={i}>
          <Reveal delay={i * 0.04} data-id="element-138" data-mp="2hbpegwkbkyr">
            <span className={`font-serif text-lg ${dark ? 'text-champagne-400' : 'text-champagne-600'}`} data-id="element-139" data-mp="2j6e86ayfx84">
              {String(i + 1).padStart(2, '0')}
            </span>
            <h3 className={`mt-2 font-serif text-2xl ${dark ? 'text-champagne-50' : 'text-midnight-900'}`} data-id="element-140" data-mp="3oy7vhih3kovh">{step.title}</h3>
            <p className={`mt-3 text-[15px] leading-relaxed ${dark ? 'text-champagne-100/70' : 'text-midnight-900/70'}`} data-id="element-141" data-mp="q87olz3clig1">
              {step.description}
            </p>
          </Reveal>
        </li>)}
    </ol>;
}